<template>
  <NavComponent />
  <section id="About">
    <div class="colored_banner">
      <h1>Mobile App</h1>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-lg-3 col-xs-12"></div>
        <div class="col-md-6 col-lg-6 col-xs-12 p-0" v-if="pageData">
          <div
            :style="{ backgroundImage: `url('${pageData.image}')` }"
            id="about_img"
          ></div>
          <div id="about_info" class="p-4 p-sm-0" v-html="pageData.text"></div>
        </div>
        <div class="col-md-3 col-lg-3 col-xs-12"></div>
      </div>
    </div>
  </section>
  <div id="line"></div>
  <FooterComponent />
</template>

<script>
import { watchEffect } from "vue";
import GetMobileApp from "@/composables/GetMobileApp";
import NavComponent from "@/views/components/Nav";
import FooterComponent from "@/views/components/Footer";
export default {
  name: "MobileAppView",
  components: {
    NavComponent,
    FooterComponent,
  },
  data() {
    return {
      data_error: null,
    };
  },
  computed:{
    pageData() {
      const data = this.$store.getters.getMobileApp;

      // Check if bannerArray is an array and has at least one element
      if (Array.isArray(data) && data.length > 0) {
        this.isLoading = false
        return data[0];
      } else {
        this.isLoading = true
        return null; // or return a default value if you prefer
      }
    }
  },
  mounted() {
    const { loadedData, data_error, loadData } = GetMobileApp();
    watchEffect(() => {
      if (!this.isRefEmpty(data_error)) {
        this.data_error = data_error.value;
      }
    });
    loadData();
  },
};
</script>


